/* Panvola article cards: Empire owns cart POSTs and the native ecommerce events. */
(function () {
  'use strict';
  if (window.__seoProductCards) return;
  window.__seoProductCards = true;

  // ponytail: Single store; move to the settings JSON if a second brand uses the theme.
  const GA4_MEASUREMENT_ID = 'G-9MQDXML2JX';

  var settingsCache = new WeakMap();
  var busyForms = new WeakSet();
  var variantQueues = new Map();
  var wired = new WeakSet();
  var viewed = new WeakSet();
  var viewedKeys = new Set();
  var visibilityTimers = new Map();
  var observedElements = new Set();
  var resizeObservers = new WeakMap();
  var pendingAdds = 0;
  var recoveryCartUrl;
  var apiPromise;

  function settingsFor(element) {
    var root = element.closest('.article--inner');
    var node = root && root.querySelector('[data-seo-card-settings]');
    if (!node) return null;
    if (!settingsCache.has(node)) {
      try { settingsCache.set(node, JSON.parse(node.textContent)); }
      catch (error) { return null; }
    }
    return settingsCache.get(node);
  }

  function publish(name, payload) {
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        var result = analytics.publish('seo:' + name, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
      var ga4Name = name === 'item_list_viewed' ? 'view_item_list' :
        name === 'product_selected' ? 'select_item' :
        name === 'content_link_click' ? 'content_link_click' : null;
      if (!ga4Name || typeof window.gtag !== 'function') return;
      var params = { send_to: GA4_MEASUREMENT_ID };
      ['brand_key', 'content_topic', 'source_article_id', 'link_placement', 'destination_type', 'content_version'].forEach(function (key) {
        if (payload[key] != null && payload[key] !== '') params[key] = payload[key];
      });
      if (ga4Name === 'view_item_list' || ga4Name === 'select_item') {
        params.item_list_id = payload.item_list_id;
        params.item_list_name = payload.item_list_name;
        var item = {
          item_id: 'shopify_US_' + payload.product_id + '_' + payload.variant_id,
          item_name: payload.item_name, item_variant: payload.item_variant,
          item_list_id: payload.item_list_id, item_list_name: payload.item_list_name
        };
        if (Number.isFinite(payload.price)) item.price = payload.price;
        if (Number.isFinite(payload.index)) item.index = payload.index;
        params.items = [item];
      }
      window.gtag('event', ga4Name, params);
    } catch (error) { /* Analytics must never affect shopping or navigation. */ }
  }

  function context(element) {
    var d = element.dataset;
    return {
      brand_key: d.brandKey, content_topic: d.contentTopic,
      source_article_id: d.sourceArticleId, link_placement: d.linkPlacement,
      destination_type: d.destinationType, content_version: d.contentVersion
    };
  }

  function itemPayload(element) {
    var d = element.dataset;
    return Object.assign(context(element), {
      product_id: Number(d.itemId), variant_id: Number(d.variantId),
      item_name: d.itemName, item_variant: d.itemVariant,
      price: Number(d.price), index: Number(d.index),
      item_list_id: d.itemListId, item_list_name: d.itemListName
    });
  }

  function viewKey(element) {
    var d = element.dataset;
    return d.sourceArticleId + ':' + d.linkPlacement + ':' + d.placementIndex + ':' + d.itemId;
  }

  function loadApi() {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return Promise.resolve();
    if (apiPromise) return apiPromise;
    apiPromise = new Promise(function (resolve, reject) {
      var scripts = document.querySelector('[data-scripts]');
      var url = scripts && scripts.getAttribute('data-shopify-api-url');
      if (!url) { reject(new Error('Missing Shopify money helper')); return; }
      var script = document.createElement('script');
      var timer = setTimeout(function () { reject(new Error('Money helper timed out')); }, 5000);
      script.src = url;
      script.async = true;
      script.onload = function () {
        clearTimeout(timer);
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') resolve();
        else reject(new Error('Money helper unavailable'));
      };
      script.onerror = function () { clearTimeout(timer); reject(new Error('Money helper failed')); };
      document.head.appendChild(script);
    });
    return apiPromise;
  }

  async function readCart(cfg) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 5000);
    try {
      var response = await window.fetch(cfg.cart_url + '.js', {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) throw new Error('Cart read failed');
      var cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
      return cart;
    } finally { clearTimeout(timer); }
  }

  function quantityFor(cart, variantId) {
    return cart.items.reduce(function (sum, item) {
      return sum + (Number(item.variant_id || item.id) === variantId ? Number(item.quantity) : 0);
    }, 0);
  }

  function finish(state, success, recoverToCart) {
    if (state.finished) return;
    // A watchdog/exception is not evidence that an in-flight POST has ended.
    if (state.ajaxStarted && !state.outcomeKnown) { showPending(state); return; }
    state.finished = true;
    clearTimeout(state.watchdog);
    state.button.disabled = false;
    state.button.classList.remove('processing');
    state.form.removeAttribute('aria-busy');
    if (state.select) state.select.disabled = false;
    busyForms.delete(state.form);
    var errorLink = state.form.querySelector('[data-seo-card-error]');
    if (errorLink) errorLink.hidden = success;
    var pendingLink = state.form.querySelector('[data-seo-card-pending]');
    if (pendingLink) pendingLink.hidden = true;
    pendingAdds -= 1;
    if (state.resolve) state.resolve();
    if (success && recoverToCart && state.cfg.cart_redirection) recoveryCartUrl = state.cfg.cart_url;
    // A fallback redirect must not abort other already accepted card adds.
    if (pendingAdds === 0 && recoveryCartUrl) {
      var destination = recoveryCartUrl;
      recoveryCartUrl = null;
      window.location.assign(destination);
    }
  }

  function showPending(state) {
    if (state.finished) return;
    state.button.disabled = true;
    var errorLink = state.form.querySelector('[data-seo-card-error]');
    if (errorLink) errorLink.hidden = true;
    var pendingLink = state.form.querySelector('[data-seo-card-pending]');
    if (pendingLink) pendingLink.hidden = false;
  }

  function settle(state, success, recoverToCart) {
    if (state.finished || state.outcomeKnown) return;
    state.confirmed = success;
    state.outcomeKnown = true;
    clearTimeout(state.watchdog);
    if (recoverToCart) { finish(state, success, true); return; }
    // The original callback and banner rendering run before this microtask.
    Promise.resolve().then(function () {
      if (state.finished) return;
      var banner = state.flyout && state.flyout.flyOut;
      if (success && banner && banner.isConnected) finish(state, true, false);
      else reconcile(state);
    });
  }

  async function reconcile(state) {
    if (state.finished || state.reconciling) return;
    state.reconciling = true;
    try {
      var cart = await readCart(state.cfg);
      if (state.finished) return;
      var increased = quantityFor(cart, state.variantId) > state.beforeQuantity;
      if (increased) settle(state, true, true);
      finish(state, state.confirmed, state.confirmed);
    } catch (error) {
      // A matching POST response still proves the add if the cart GET is down.
      finish(state, state.confirmed === true, state.confirmed === true);
    } finally { state.reconciling = false; }
  }

  async function attempt(state) {
    try { await loadApi(); }
    catch (error) {
      // No flyout has been constructed and no AJAX POST can have been sent.
      if (state.select) state.select.disabled = false;
      // Keep the submit button/busy guard until native navigation takes over.
      HTMLFormElement.prototype.submit.call(state.form);
      return;
    }
    try {
      state.beforeQuantity = quantityFor(await readCart(state.cfg), state.variantId);
    } catch (error) { finish(state, false, false); return; }
    return new Promise(function (resolve) {
      state.resolve = resolve;
      state.watchdog = setTimeout(function () { reconcile(state); }, 8000);
      try {
        // Constructor exceptions may happen after POST; treat them as unknown.
        state.ajaxStarted = true;
        const flyout = new window.AddToCartFlyout(state.formData, {
          atcButton: state.button,
          settings: { moneyFormat: state.cfg.money_format, cartRedirection: state.cfg.cart_redirection }
        });
        state.flyout = flyout;
        const okOrig = flyout.callbacks.onSuccess;
        flyout.callbacks.onSuccess = (...a) => { settle(state, true); return okOrig.apply(flyout, a); };
        const errorOrig = flyout.callbacks.onError;
        flyout.callbacks.onError = (...a) => { settle(state, false); return errorOrig.apply(flyout, a); };
      } catch (error) { reconcile(state); }
    });
  }

  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    var form = event.target.closest && event.target.closest('form[data-seo-card-form]');
    // Before Empire boot, the real product form retains its native /cart/add path.
    if (!form) return;
    // Even if dependencies disappear, a pending form must never submit again.
    if (busyForms.has(form)) { event.preventDefault(); return; }
    if (!window.AddToCartFlyout || !window.jQuery) return;
    var cfg = settingsFor(form);
    var card = form.closest('[data-article-product-card]');
    var button = form.querySelector('[data-seo-card-atc]');
    if (!cfg || !card || !button) return;
    var formData = window.jQuery(form).serializeArray();
    var idField = formData.find(function (field) { return field.name === 'id'; });
    var variantId = Number(idField && idField.value);
    if (!idField || !/^[0-9]+$/.test(idField.value) || !Number.isSafeInteger(variantId) || variantId <= 0) return;
    event.preventDefault();
    var state = { form: form, formData: formData, button: button, cfg: cfg, variantId: variantId,
      select: form.querySelector('select[name="id"]'), finished: false, confirmed: false,
      ajaxStarted: false, outcomeKnown: false };
    busyForms.add(form);
    pendingAdds += 1;
    button.disabled = true;
    button.classList.add('processing');
    form.setAttribute('aria-busy', 'true');
    if (state.select) state.select.disabled = true;
    var payload = itemPayload(card);
    payload.variant_id = variantId;
    publish('add_intent', payload);
    // Repeated placements of one variant take separate snapshots and cannot
    // claim each other's completion. Different variants can add concurrently.
    var previous = variantQueues.get(variantId) || Promise.resolve();
    var work = previous.catch(function () {}).then(function () { return attempt(state); });
    variantQueues.set(variantId, work);
    work.catch(function () { finish(state, false, false); }).then(function () {
      if (variantQueues.get(variantId) === work) variantQueues.delete(variantId);
    });
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-article-product-card] select[name="id"]');
    if (!select) return;
    var card = select.closest('[data-article-product-card]');
    var option = select.selectedOptions[0];
    if (!option || option.disabled) return;
    Object.assign(card.dataset, { variantId: option.value, itemVariant: option.dataset.itemVariant, price: option.dataset.price });
    var price = card.querySelector('[data-price-display]');
    var current = price.querySelector('[data-price-container]');
    var compare = price.querySelector('[data-price-compare-container]');
    var onSale = Number(option.dataset.comparePrice) > Number(option.dataset.price) * 100;
    // Clone the price snippet's localized markup and use Liquid-formatted money.
    current.innerHTML = price.querySelector('[data-current-price-hidden]').innerHTML;
    current.querySelector('[data-price]').textContent = option.dataset.priceMoney;
    current.classList.toggle('price__current--on-sale', onSale);
    compare.innerHTML = price.querySelector('[data-compare-price-hidden]').innerHTML;
    compare.querySelector('[data-price-compare]').textContent = option.dataset.compareMoney;
    compare.classList.toggle('visible', onSale);
    card.classList.toggle('productitem--sale', onSale);
  });

  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function linkClickGuard(scope) {
    var pointer;
    scope.addEventListener('pointerdown', function (event) {
      var link = event.target.closest && event.target.closest('a');
      pointer = link && event.pointerType === 'mouse' ?
        { link: link, id: event.pointerId, x: event.clientX, y: event.clientY, moved: false } : null;
    }, { passive: true });
    function recordMovement(event) {
      if (pointer && pointer.id === event.pointerId &&
          Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) > 6) pointer.moved = true;
    }
    scope.addEventListener('pointermove', recordMovement, { passive: true });
    scope.addEventListener('pointerup', recordMovement, { passive: true });
    scope.addEventListener('pointercancel', function () { pointer = null; }, { passive: true });
    return function (event) {
      var previous = pointer;
      pointer = null;
      if (!previous || !previous.moved || event.detail === 0) return;
      var link = event.target.closest && event.target.closest('a');
      if (link === previous.link) event.preventDefault();
    };
  }

  function wireGallery(gallery) {
    var guardClick = linkClickGuard(gallery);
    var track = gallery.querySelector('[data-gallery-track]');
    var count = Number(gallery.dataset.count);
    var dots = gallery.querySelectorAll('[data-gal-to]');
    var previous = gallery.querySelector('[data-gal-step="-1"]');
    var next = gallery.querySelector('[data-gal-step="1"]');
    function index() { return Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / (track.clientWidth || 1)))); }
    function paint() {
      var current = index();
      dots.forEach(function (dot, i) { if (i === current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (previous) { previous.disabled = current === 0; next.disabled = current === count - 1; }
    }
    track.addEventListener('scroll', paint, { passive: true });
    track.addEventListener('focusin', function (event) {
      var slide = event.target.closest && event.target.closest('.seo-card__slide');
      if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    if (window.ResizeObserver) {
      var resizer = new window.ResizeObserver(paint);
      resizer.observe(track);
      resizeObservers.set(track, resizer);
    }
    gallery.addEventListener('click', function (event) {
      guardClick(event);
      if (event.defaultPrevented) return;
      var step = event.target.closest('[data-gal-step]');
      var to = event.target.closest('[data-gal-to]');
      if (!step && !to) return;
      var target = to ? Number(to.dataset.galTo) : index() + Number(step.dataset.galStep);
      track.scrollTo({ left: Math.max(0, Math.min(count - 1, target)) * track.clientWidth, behavior: scrollBehavior() });
    });
    paint();
  }

  function wireRow(row) {
    var guardClick = linkClickGuard(row);
    var track = row.querySelector('[data-row-track]');
    var previous = row.querySelector('[data-row-step="-1"]');
    var next = row.querySelector('[data-row-step="1"]');
    function paint() {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }
    track.addEventListener('scroll', paint, { passive: true });
    if (window.ResizeObserver) {
      var resizer = new window.ResizeObserver(paint);
      resizer.observe(track);
      resizeObservers.set(track, resizer);
    }
    row.addEventListener('click', function (event) {
      guardClick(event);
      if (event.defaultPrevented) return;
      var step = event.target.closest('[data-row-step]');
      if (step) track.scrollBy({ left: Number(step.dataset.rowStep) * track.clientWidth, behavior: scrollBehavior() });
    });
    paint();
  }

  function hasViewed(element) { return viewed.has(element) || viewedKeys.has(viewKey(element)); }

  var observer = window.IntersectionObserver && new window.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var element = entry.target;
      clearTimeout(visibilityTimers.get(element));
      visibilityTimers.delete(element);
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !hasViewed(element) && !document.hidden) {
        visibilityTimers.set(element, setTimeout(function () {
          visibilityTimers.delete(element);
          if (!element.isConnected || document.hidden) return;
          viewed.add(element);
          viewedKeys.add(viewKey(element));
          observedElements.delete(element);
          observer.unobserve(element);
          publish('item_list_viewed', itemPayload(element));
        }, 1000));
      }
    });
  }, { threshold: [0, 0.5] });

  function initialize(scope) {
    scope.querySelectorAll('[data-seo-card-settings]').forEach(function (settingsNode) {
      var root = settingsNode.closest('.article--inner');
      var cfg = root && settingsFor(root);
      if (!cfg) return;
      // H2 ordinal is the number of authored .rte H2s preceding the card.
      // s0 is the introduction. All grids share __shop; the row shares __product_row.
      var sectionNumber = 0, heading = 'Introduction', counters = new Map();
      root.querySelectorAll('.rte h2, [data-article-product-card]').forEach(function (element) {
        if (element.tagName === 'H2') {
          sectionNumber += 1; heading = element.textContent.trim();
          return;
        } else {
          var placement = element.dataset.linkPlacement;
          var suffix = placement === 'product_row' ? 'product_row' : placement === 'shop_section' ? 'shop' : 's' + sectionNumber;
          var list = cfg.content_topic + '__' + suffix;
          var number = (counters.get(list) || 0) + 1;
          counters.set(list, number);
          element.dataset.itemListId = list;
          element.dataset.itemListName = cfg.article_title + ' — ' + (placement === 'product_row' ? 'Product row' : placement === 'shop_section' ? 'Shop' : heading);
          element.dataset.index = String(number);
        }
        if (viewedKeys.has(viewKey(element))) viewed.add(element);
        if (observer && !hasViewed(element)) {
          observedElements.add(element);
          observer.observe(element);
        }
      });

      root.querySelectorAll('[data-gallery], [data-seo-row]').forEach(function (element) {
        if (wired.has(element)) return;
        wired.add(element);
        if (element.hasAttribute('data-gallery')) wireGallery(element);
        if (element.hasAttribute('data-seo-row')) wireRow(element);
      });
      // api.jquery.js also needs jQuery; early submits keep the native path.
      if (window.jQuery) loadApi().catch(function () {});
    });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;
    var card = link.closest('[data-article-product-card]');
    if (card && link.hasAttribute('data-card-link')) publish('product_selected', itemPayload(card));
    else if (link.closest('[data-seo-row]') && link.hasAttribute('data-content-link')) publish('content_link_click', context(link));
  });

  document.addEventListener('visibilitychange', function () {
    visibilityTimers.forEach(function (timer) { clearTimeout(timer); });
    visibilityTimers.clear();
    // Re-observing on return restarts a full continuous visible second.
    if (!document.hidden && observer) observedElements.forEach(function (element) {
      if (!element.isConnected) { observedElements.delete(element); observer.unobserve(element); return; }
      observer.unobserve(element); observer.observe(element);
    });
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-article-product-card]').forEach(function (element) {
      clearTimeout(visibilityTimers.get(element)); visibilityTimers.delete(element);
      observedElements.delete(element);
      if (observer) observer.unobserve(element);
    });
    event.target.querySelectorAll('[data-gallery-track], [data-row-track]').forEach(function (track) {
      var resizer = resizeObservers.get(track);
      if (resizer) resizer.disconnect();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
})();
